BennesController.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'$translate',
	'ModalService',
	'PaginationService',
	'BennesService',
	'notification',
	'MOPService'
];

export default function BennesController(
	$scope,
	$state,
	$stateParams,
	$translate,
	ModalService,
	PaginationService,
	BennesService,
	notification,
	MOPService
) {
	const vm = this;

	let previousTableState;

	vm.loading = false;
	vm.params = $stateParams;
	vm.state = $state;
	vm.bennes = [];
	vm.isEnabled = true;
	vm.previousIsEnabled = true;

	vm.slideWidth = '500px';
	vm.slideMargin = {
		'margin-right': '0px',
		'transition-duration': '0.5s',
		'transition-animation': 'margin-right',
		height: '100%'
	};
	vm.itemsByPageOptions = [20, 100, 200];
	vm.itemsByPage = vm.itemsByPageOptions[0];

	vm.loadBennes = loadBennes;
	vm.deleteBenne = deleteBenne;
	vm.createUpdateBenne = createUpdateBenne;
	vm.onBenneChange = onBenneChange;
	vm.activeEditMode = activeEditMode;
	vm.desactiveEditMode = desactiveEditMode;
	vm.activateBenne = activateBenne;
	vm.MOPService = MOPService;

	async function init() {
		vm.MOPService.setMop([{ title: 'BENNES.BREADCRUMBS.BENNES_LIST', filename: 'Vehicules.pdf', application: 'gestion' }]);
		vm.typeBennes = await BennesService.getTypeBennes();
		vm.typeBennes.forEach((t) => {
			t.label = t.libelle;
		});
	}

	init();

	vm.$onDestroy = () => {
		vm.MOPService.resetMop();
	};

	async function loadBennes(tableState) {
		startLoading();

		if ($state && $state.current && $state.current.name !== 'bennes.list') {
			$state.go('bennes.list');
		}

		if (tableState) {
			previousTableState = tableState;
		}

		const filters = PaginationService.getFilters(previousTableState);
		const sorts = PaginationService.getSorts(previousTableState);
		const pagination = PaginationService.getPagination(previousTableState);

		if (vm.isEnabled != vm.previousIsEnabled) {
			pagination.skip = 0;
			vm.previousIsEnabled = vm.isEnabled;
		}

		vm.isEditMode = false;
		vm.bennes = [];
		vm.newBenne = {};

		try {
			const data = await BennesService.getBennes(vm.isEnabled, filters, sorts, pagination);

			vm.bennes = data.items;

			if (previousTableState) {
				PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function deleteBenne(benne) {
		if (benne && benne.id) {
			const modalInstance = ModalService.confirm({
				modalTitle: $translate.instant('BENNES.DELETE.TITLE'),
				modalMsg: $translate.instant('BENNES.DELETE.MESSAGE'),
				headerClass: 'modal-danger'
			});

			modalInstance.result.then(async function () {
				startLoading();
				try {
					await BennesService.deleteBenneById(benne.id);
					notification.success($translate.instant('BENNES.DELETE.SUCCESS'));
					loadBennes();
				} catch (ex) {
					if (ex.status == 500) {
						notification.error('BENNES.DELETE.NOTDELETABLE');
					} else notification.error(ex.data);
				} finally {
					stopLoading();
				}
			});
		}
	}

	async function activateBenne(idBenne) {
		await BennesService.activateBenne(idBenne);
		loadBennes();
	}

	function onBenneChange(benne, input) {
		if (input === 'ptac') {
			benne.ptacError = false;
			const num = Number(benne.ptac);
			if (isNaN(num) || num <= 0) {
				benne.ptacError = true;
			}
		}

		if (input === 'immatriculation') {
			benne.immatriculationError = false;
			if (benne.immatriculation.length > 15) {
				benne.immatriculationError = true;
			} else if (!isValidImmatriculation(benne.immatriculation)) {
				benne.immatriculationError = true;
			}
		}
		if (input === 'typeBenne') {
			benne.typeBenneError = false;
			if (!benne.typeBenneId) {
				benne.typeBenneError = true;
			}
		}
	}

	function activeEditMode(benne) {
		if (vm.isEditMode) return;
		vm.isEditMode = true;
		benne.isEditMode = true;
	}

	function desactiveEditMode(benne) {
		vm.isEditMode = false;
		benne.isEditMode = false;
	}

	async function createUpdateBenne(benne, isCreate) {
		if (isCreate || (!isCreate && benne && benne.id)) {
			if (benne.immatriculation && benne.ptac) {
				startLoading();
				try {
					let isOk = true;
					if (!isValidPTAC(benne.ptac)) {
						isOk = false;
						notification.error($translate.instant('BENNES.PTAC_ERROR'));
					}
					if (benne.immatriculation.length > 15) {
						isOk = false;
						notification.error($translate.instant('BENNES.IMMATRICULATION_TOO_LONG'));
					} else if (!isValidImmatriculation(benne.immatriculation)) {
						isOk = false;
						notification.error($translate.instant('BENNES.IMMATRICULATION_WRONG_CHAR'));
					}
					if (!benne.typeBenneId) {
						isOk = false;
						notification.error($translate.instant('BENNES.TYPE_BENNE_ERROR'));
					}
					if (isOk) {
						if (isCreate) {
							await BennesService.createBenne(benne);
							notification.success($translate.instant('BENNES.CREATE.SUCCESS'));
						} else {
							await BennesService.updateBenne(benne);
							notification.success($translate.instant('BENNES.UPDATE.SUCCESS'));
						}
						vm.newBenne = {};
						loadBennes();
					}
				} catch (ex) {
					notification.error(ex.data);
				} finally {
					stopLoading();
				}
				// });
			} else if (!benne.immatriculation && !benne.ptac) notification.error('BENNES.CREATE.MISSINGDATA');
			else if (!benne.immatriculation) notification.error('BENNES.CREATE.MISSINGIMMAT');
			else if (!benne.ptac) notification.error('BENNES.CREATE.MISSINGPTAC');
		}
	}
	function isValidImmatriculation(value) {
		//Autoriser uniquement les chiffres, les lettres non accentuées, les espaces et le tiret "-"
		const regex = /^[a-zA-Z0-9 \-_]+$/;
		return regex.test(value);
	}
	function isValidPTAC(value) {
		// Autoriser uniquement les chiffres et les séparateurs numériques "," et "."
		const regex = /^[0-9.,]+$/;
		return regex.test(value);
	}
	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}
}
